import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const useUploadVesselDocumentsWithAuth = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();
  const vesselId = localStorage.getItem("vesselId");
  const navigate = useNavigate();

  const uploadVesselDocuments = async (formData) => {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/vessel/upload/otherDocuments/${vesselId}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }
    );

    if (!response.ok) {
      const errorResponse = await response.json();
      throw new Error(errorResponse.message || "Failed to upload document");
    }

    return response.json();
  };

  const skipUploadVesselDocuments = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/vessel/upload/otherDocuments/${vesselId}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ skipped: true }),
      }
    );

    if (!response.ok) {
      const errorResponse = await response.json();
      throw new Error(errorResponse.message || "Failed to skip document upload");
    }

    return response.json();
  };

  const mutation = useMutation(uploadVesselDocuments, {
    onSuccess: () => {
      queryClient.invalidateQueries("vesselData");
      navigate("/dashboard/myvessels");
    },
    onError: (err) => {
      toast.error(err.message || "An error occurred during document upload. Please try again.");
    },
  });

  const skipMutation = useMutation(skipUploadVesselDocuments, {
    onSuccess: () => {
      queryClient.invalidateQueries("vesselData");
      toast.success("Skipped document upload");
      navigate("/dashboard/myvessels");
    },
    onError: (err) => {
      toast.error(err.message || "An error occurred while skipping the document upload.");
    },
  });

  return { ...mutation, skipMutation };
};

export default useUploadVesselDocumentsWithAuth;

